import { Box, Card, CardContent, Divider, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { CustomerDetailInterface } from "../../Objects/Customer";
import CustomerAddress from "../atoms/CustomerAddress";
import CustomerBirthday from "../atoms/CustomerBirthday";
import CustomerGender from "../atoms/CustomerGender";
import CustomerMail1 from "../atoms/CustomerMail1";
import CustomerMail2 from "../atoms/CustomerMail2";
import CustomerMemo from "../atoms/CustomerMemo";
import CustomerName from "../atoms/CustomerName";
import CustomerTel1 from "../atoms/CustomerTel1";
import CustomerTel2 from "../atoms/CustomerTel2";
import MemberJoinDate from "../atoms/MemberJoinDate";
import MemberPoint from "../atoms/MemberPoint";
import MemberRenewDate from "../atoms/MemberRenewDate";
import MembershipCode from "../atoms/MembershipCode";
import MemberValidityDate from "../atoms/MemberValidityDate";
import MypageReg from "../atoms/MypageReg";

export interface CustomerDetailCardProps {
    customerData: CustomerDetailInterface
}

const CustomerDetailCard: React.FC<CustomerDetailCardProps> = ({
    customerData
}) => {

    return (
        <Card variant="outlined">
            <CardContent>
                <Stack
                    spacing={0.5}
                >
                    {customerData.delete_flug=="1" &&
                        <Typography variant="body2" color="error">抹消済みユーザー</Typography>
                    }
                    <CustomerName customerData={customerData} />
                    <Divider />
                    <MembershipCode customerData={customerData} />
                    <Box>
                        <Grid container>
                            <Grid item xs={12} sm={6} md={4}>
                                <MemberJoinDate customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MemberRenewDate customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <MemberValidityDate customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MemberPoint customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MypageReg customerData={customerData} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider/>
                    <Box>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <CustomerBirthday customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomerGender customerData={customerData} />
                            </Grid>
                            <Grid item xs={12}>
                                <CustomerAddress customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomerTel1 customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomerTel2 customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomerMail1 customerData={customerData} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomerMail2 customerData={customerData} />
                            </Grid>
                        </Grid>
                    </Box>
                    
                    <Divider />
                    <CustomerMemo customerData={customerData} />
                </Stack>
            </CardContent>
        </Card>
    )
}

export default CustomerDetailCard